import React from 'react';
import { PlanIds } from '../data/account';
import Utils from '../utils';
import { UpgradeMessage } from './UpgradeMessage.component';

const { BillingPlans } = Utils;
const { prettyPrintPlan } = BillingPlans;

// Parse plan `Summary` string from backend BillingPlans endpoint.
// Shape: "<tag>  -<subHeader>  -<feature1>  -<feature2>..."
const parseFeatures = (summary = '') => {
	const segments = summary ? summary.split('  -').filter(t => t !== '') : [];
	return segments.length > 2 ? segments.slice(2).map(s => s.trim()) : [];
};

const UpgradePlanContent = ({ data }) => {
	const { upgradePlan } = data;
	const { Name, Price, PlanId, Summary } = upgradePlan;

	const renderPlanInfo = () => {
		if (PlanId === PlanIds.Professional403) {
			const features = parseFeatures(Summary);
			return (
				<div>
					<ul>
						{features.map((feature, i) => (
							<li key={i}>{feature}</li>
						))}
					</ul>
				</div>
			);
		} else if (PlanId === PlanIds.Office || PlanId === PlanIds.OfficeV381) {
			return (
				<div>
					<ul>
						<li>3 account users</li>
						<li>Multi-address shipping</li>
						<li>Confidential postage on shipping labels</li>
						<li>
							And{' '}
							<a
								href="https://www.stamps.com/pricing/"
								target="_blank"
								rel="noreferrer"
							>
								much more
							</a>
						</li>
					</ul>
				</div>
			);
		} else if (PlanId === PlanIds.Core || PlanId === PlanIds.CoreV380) {
			return (
				<div>
					<ul>
						<li>Reprint from history</li>
						<li>Certified mail forms</li>
						<li>Discounted insurance</li>
						<li>
							And{' '}
							<a
								href="https://www.stamps.com/pricing/"
								target="_blank"
								rel="noreferrer"
							>
								much more
							</a>
						</li>
					</ul>
				</div>
			);
		} else {
			return (
				<div>
					<ul>
						<li>5 account users</li>
						<li>Order import and product management</li>
						<li>Barcode scanning and automation</li>
						<li>
							And{' '}
							<a
								href="https://www.stamps.com/pricing/"
								target="_blank"
								rel="noreferrer"
							>
								much more
							</a>
						</li>
					</ul>
				</div>
			);
		}
	};

	const renderUpgradeMessage = () => (
		<p>
			Upgrade to the <strong>{prettyPrintPlan(Name)}</strong> plan to use this
			feature.{' '}
		</p>
	);

	const renderPricePanel = () => (
		<div className="price-panel">
			<p className="plan-name">
				<strong>{prettyPrintPlan(Name)} Plan</strong>
			</p>
			<p className="plan-price">
				<strong>${Price}</strong> / month
			</p>
		</div>
	);

	return (
		<div className="default-upgrade-content">
			<div className="left-content">
				<UpgradeMessage>{renderUpgradeMessage()}</UpgradeMessage>
				<div className="plan-info">
					<p>
						Upgrading to the {prettyPrintPlan(Name)} plan gives you this
						feature, plus:
					</p>
					{renderPlanInfo()}
				</div>
				<hr />
				{renderPricePanel()}
				<hr />
			</div>
		</div>
	);
};

export default UpgradePlanContent;
